import React from 'react';
import { useTranslation } from "react-i18next";
import { Input, TextArea } from '@progress/kendo-react-inputs';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { Button } from '@progress/kendo-react-buttons';
import { DropDownList } from '@progress/kendo-react-dropdowns';


export default function TasksDetailsComoponents() {

    const { t } = useTranslation();


    const [value, setValue] = React.useState(new Date());
    const [vista, setVista] = React.useState('');

    const sports = [
        'Baseball',
        'Basketball',
        'Cricket',
        'Volleyball'
    ];

    const changeDate = ({ value }) => {
        setValue(value);
    };

    return (
        <div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3 px-4">
                            <h5 className="card-title m-0">{t("Global_Label_Text_General")}</h5>
                        </div>

                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-12 col-md-4">
                                    <FloatingLabel label={t("Global_Label_Text_Farm")} editorId="ciudadVista" editorValue={vista}>
                                        <DropDownList
                                            id="ciudadVista"
                                            style={{ width: '100%' }}
                                            data={sports}
                                            value={vista}
                                            onChange={(e) => setVista(e.target.value)}
                                            defaultItem="Selecciona ciudad"
                                        />
                                    </FloatingLabel>
                                </div>

                                <div className="col-12 col-md-4">
                                    <DateTimePicker
                                        label={t("Global_Label_Text_Start_Date")}
                                        value={value}
                                        onChange={changeDate}
                                        style={{ width: "100%" }}
                                    />
                                </div>

                                <div className="col-12 col-md-4">
                                    <DateTimePicker
                                        label={t("Global_Label_Text_Date_End")}
                                        value={value}
                                        onChange={changeDate}
                                        style={{ width: "100%" }}
                                    />
                                </div>

                                <div className="col-12 col-md-6">
                                    <Input
                                        label={t("Global_Label_Text_Issue")}
                                        style={{ width: "100%" }}
                                    />
                                </div>

                                <div className="col-12 col-md-6">
                                    <Input
                                        label={t("Global_Label_Text_Animal")}
                                        style={{ width: "100%" }}
                                    />
                                </div>

                                <div className="col-12 col-md-4">
                                    <FloatingLabel label={t("Global_Label_Text_Group")} editorId="ciudadVista2" editorValue={vista}>
                                        <DropDownList
                                            id="ciudadVista2"
                                            style={{ width: '100%' }}
                                            data={sports}
                                            value={vista}
                                            onChange={(e) => setVista(e.target.value)}
                                            defaultItem="Selecciona ciudad"
                                        />
                                    </FloatingLabel>
                                </div>
                                <div className="col-12 col-md-4">
                                    <FloatingLabel label={t("Global_Label_Text_Template")} editorId="ciudadVista2" editorValue={vista}>
                                        <DropDownList
                                            id="ciudadVista2"
                                            style={{ width: '100%' }}
                                            data={sports}
                                            value={vista}
                                            onChange={(e) => setVista(e.target.value)}
                                            defaultItem="Selecciona ciudad"
                                        />
                                    </FloatingLabel>
                                </div>
                                <div className="col-12 col-md-4">
                                    <FloatingLabel label={t("Global_Label_Text_Assigned")} editorId="ciudadVista2" editorValue={vista}>
                                        <DropDownList
                                            id="ciudadVista2"
                                            style={{ width: '100%' }}
                                            data={sports}
                                            value={vista}
                                            onChange={(e) => setVista(e.target.value)}
                                            defaultItem="Selecciona ciudad"
                                        />
                                    </FloatingLabel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_Remarks")}</h5>
                        </div>

                        <div className="container p-3 p-md-4">
                            <div className="row g-3 mb-3 mb-md-4">
                                <TextArea
                                    label={t("Global_Label_Text_Remarks")}
                                    rows={4}
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_Remarks")}</h5>
                        </div>
                        
                    </div>
                </div>
            </div>


            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="d-flex justify-content-end mb-3">
                        <Button className="action-button me-lg-11">{t("Global_Label_Text_Save")}</Button>
                    </div>
                </div>
            </div>

        </div>
    );
}
